import {useSessionData} from "./SessionDataProvider";
import {Outlet} from "react-router-dom";

function RequireAuth({ children })
{
    const { sessionData } = useSessionData();

    if (!sessionData.isLogged) {
        return null;
    }

    return children || <Outlet />;
}

export default RequireAuth
